import React from 'react';
// import PropTypes from 'prop-types';
// import classNames from 'classnames';
import { withRouter } from 'react-router';
import { css } from 'react-emotion';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { Formik, Field, Form, FieldArray } from 'formik';
import filter from 'lodash/filter';

import AddPlanButton from './ModalButtons/AddPlan';
import Loading from '../../components/Loading';

const sideError = css({
  display: 'block',
  fontFamily: 'arial',
  fontSize: '.875rem',
  color: '#dc3545',
});

const FormGroup = ({ render }) => <div className="form-group">{render()}</div>;

const InputField = ({
  type = 'text',
  label,
  placeholder,
  help,
  disabled,
  field,
  form,
  ...inputRest
}) => {
  return (
    <FormGroup
      render={() => (
        <div>
          <label htmlFor={field.name}>{label}</label>
          <div
            style={{
              position: 'relative',
            }}
          >
            <input
              type={type}
              className="form-control"
              aria-describedby={field.name}
              placeholder={placeholder}
              disabled={disabled}
              {...field}
              {...inputRest}
            />
            {form.errors[field.name] && (
              <div className={sideError}>{form.errors[field.name]}</div>
            )}
          </div>
          {help && <small className="form-text text-muted">{help}</small>}
        </div>
      )}
    />
  );
};

const createSubscription = gql`
  mutation createSubscription($organizationId: ID!, $subscriptionItems: JSON) {
    createSubscription(
      organizationId: $organizationId
      subscriptionItems: $subscriptionItems
    ) {
      id
      created_at
      updated_at
      deleted_at
      restored_at
      items {
        id
        subscription_id
        plan_id
        plan {
          id
          name
          interval
          amount
        }
        qty
        created_at
        updated_at
        restored_at
        deleted_at
      }
    }
  }
`;

const withMutation = graphql(createSubscription, {
  props: ({ mutate }) => ({
    createSubscription: values => {
      return mutate({
        variables: values,
        // update: (proxy, { data: { updateSubscription } }) => {
        //   proxy.writeQuery({
        //     query: queryOrganizationSubscription,
        //     variables: { organizationId: values.organizationId.toString() },
        //     data: {
        //       organizationSubscription: updateSubscription,
        //     },
        //   });
        // },
        // update: (proxy, { data: { signUp } }) => {
        //   debugger;

        //   // TODO: is the user being saved correctly locally?

        //   // const query = queryNotifications;
        //   // const variables = { id: notificationId };
        //   // const data = proxy.readQuery({ query, variables });
        //   // readNotification.forEach(rn => {
        //   //   const index = data.myNotifications.findIndex(n => n.id === rn.id);
        //   //   if (index > -1) data.myNotifications.splice(index, 1);
        //   // });
        //   // proxy.writeQuery({ query, data });
        // },
        // TODO: optimisticResponse
      });
    },
  }),
});

@withRouter
@withMutation
export class AddPlansForm extends React.Component {
  state = {
    addedPlans: [],
  };

  addPlan = plan => {
    const newPlan = { plan_id: plan.id, name: plan.name, amount: plan.amount, interval: plan.interval };
    const addedPlans = this.state.addedPlans.concat(newPlan);
    this.setState({ addedPlans });
  };

  removePlan = plan => {
    const updatedPlans = filter(this.state.addedPlans, p => {
      return p.plan_id !== plan.plan_id;
    });
    this.setState({ addedPlans: updatedPlans });
  };

  render() {
    const { addedPlans } = this.state;
    const {
      createSubscription,
      params: { organizationId },
      router,
    } = this.props;
    const initialValues = {
      plans: [],
    };

    initialValues.plans = addedPlans.reduce((result, item, index) => {
      console.log('ttt', item);
      const value = {
        name: item.name || null,
        plan_id: item.plan_id,
        qty: item.qty || 1,
        amount: item.amount,
        interval: item.interval,
        deleted: false,
        fromAddedState: true,
      };
      result.push(value);
      return result;
    }, []);

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        // validationSchema={schema}
        onSubmit={async (
          values,
          { setSubmitting, setErrors /* setValues and other goodies */ },
        ) => {
          setSubmitting(true);
          try {
            const plans = filter(values.plans, p => {
              return p.deleted === false && p.qty > 0;
            }).map(p => ({ plan_id: p.plan_id, quantity: p.qty }));
            console.log('values', values, plans);
            await createSubscription({
              organizationId,
              subscriptionItems: plans,
            });
          } catch (e) {
            console.log('e', e);
          }
          setSubmitting(false);
          router.push(`/admin/organization/${organizationId}`);
        }}
        render={({ setFieldValue, isSubmitting, values }) => (
          <Form>
            <div>
              <div className="card">
                <div className="card-header d-flex justify-content-between">
                  <span>Plans</span>
                  <AddPlanButton
                    addPlan={this.addPlan}
                    addedPlans={values.plans}
                  />
                </div>
                <div className="card-body">
                  <ul className="list-group">
                    <FieldArray
                      name="plans"
                      render={arrayHelpers => (
                        <div>
                          {values.plans &&
                            values.plans.length > 0 &&
                            values.plans.map((p, idx) => {
                              console.log('planRow', p);
                              const removedPlanClass =
                                values.plans[idx] && values.plans[idx].deleted
                                  ? 'list-group-item-secondary'
                                  : null;

                              const priceInterval = `$${parseInt(p.amount, 10)/100}/${p.interval}`;

                              return (
                                <li
                                  className={`list-group-item d-flex justify-content-between ${removedPlanClass}`}
                                  key={idx}
                                >
                                  <div>
                                    <span>{p.name}</span>
                                    <div className="text-muted">{priceInterval}</div>
                                  </div>
                                  <div className="form-inline">
                                    <button
                                      type="button"
                                      className="btn btn-link"
                                      onClick={() => {
                                        if (values.plans[idx].fromAddedState) {
                                          this.removePlan(p);
                                        } else {
                                          setFieldValue(
                                            `plans.${idx}.deleted`,
                                            values.plans[idx] &&
                                            values.plans[idx].deleted
                                              ? false
                                              : true,
                                          );
                                        }
                                      }}
                                    >
                                      {values.plans[idx] &&
                                      values.plans[idx].deleted
                                        ? 'Restore'
                                        : 'Remove'}
                                    </button>

                                    <Field
                                      key={idx}
                                      component={InputField}
                                      name={`plans.${idx}.qty`}
                                      type="number"
                                      className="form-control form-control-sm"
                                      min="0"
                                    />
                                  </div>
                                </li>
                              );
                            })}
                        </div>
                      )}
                    />
                  </ul>
                </div>
              </div>
              <div
                className="d-flex justify-content-end"
                style={{ marginTop: 20 }}
              >
                <button
                  type="submit"
                  className="btn btn-primary btn-sm"
                  disabled={isSubmitting || values.plans.length === 0}
                >
                  {!isSubmitting && 'Save'}
                  {isSubmitting && (
                    <span>
                      <i className="fa fa-spinner fa-pulse fa-fw" /> Save
                    </span>
                  )}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary btn-sm ml-2"
                  disabled={isSubmitting}
                  onClick={() => {
                    router.push(`/admin/organization/${organizationId}`);
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <span>
                    <i className="fa fa-arrow-left" /> Back to Subscriptions
                  </span>
                </button>
              </div>
            </div>
          </Form>
        )}
      />
    );
  }
}

const createSubscriptionPageQuery = gql`
  query organization($id: ID!) {
    organization(id: $id) {
      id
      name
      plan_id
      current_card_id
      stripe_customer_id
      created_at
      updated_at
      deleted_at
      restored_at
    }
  }
`;

const withData = graphql(createSubscriptionPageQuery, {
  options: ({ params }) => ({
    variables: {
      id: params.organizationId,
    },
    fetchPolicy: 'network-only',
  }),
});

@withRouter
@withData
export default class CreateSubscriptionPage extends React.Component {
  render() {
    const { data: { organization, loading } } = this.props;
    if (loading) return <Loading />;
    // console.log('hoc', this.props);
    return (
      <div>
        <div className="card" style={{}}>
          <div className="card-header">
            <span>Customer</span>
          </div>
          <div className="card-body d-flex justify-content-between">
            <span>{organization.name}</span>
            <span>{organization.stripe_customer_id}</span>
          </div>
        </div>
        <AddPlansForm />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateSubscription.js